type PaymentError = {
    type?: string;
    message?: string;
    payment_intent?: { status: string };
};

export const PAYMENT_STATUS_UNKNOWN = "Payment status unavailable. Reload this page before trying again.";

export function confirmedPaymentFailure(reason?: string) {
    return `Payment failed. Nothing was charged. ${reason || "Update your card or try again."}`;
}

export function paymentFailureMessage(error: PaymentError): string {
    if (error.type === "validation_error") return error.message || "Check your payment details.";
    if (error.payment_intent?.status === "requires_payment_method") return confirmedPaymentFailure(error.message);
    if (error.type === "card_error") return error.message || "Your card was declined. Try another card.";
    return PAYMENT_STATUS_UNKNOWN;
}
